module.exports = __webpack_public_path__ + "static/media/Nconf9.bd8fabdb.png";